/**
 * ItemDoSinoDoPortal — a linha do sino na voz do Início (D3, desenho do portal 0.9 e 2.4). O `NotificationItem` do interno fala outro dialeto
 * (ponto azul, ícone por severidade, "há cerca de 5 minutos"): o parceiro veria duas versões da MESMA notificação no mesmo portal. Aqui é a
 * linha do `PainelDeNotificacoes` do Início encolhida (ponto `emerald-600`, título em negrito se não lida, `tempoRelativo`, fundo verde claro).
 * Mantém os testids que o sino já tinha. 78 px de altura (12 + 20 + 18 + 16 + 12): 5 itens à vista no Popover de 400 px.
 */
import type { PropsDoItemDoSino } from "@/components/notifications/PainelDoSino";
import { dataHoraCompleta, tempoRelativo } from "@/components/portal/inicio/tempoRelativo";
import { cn } from "@/lib/utils";

export function ItemDoSinoDoPortal({ notification: n, onRead }: PropsDoItemDoSino) {
  return (
    <button
      type="button"
      onClick={() => onRead(n.id)}
      data-testid="portal-notification-item"
      data-lida={n.is_read ? "sim" : "nao"}
      className={cn(
        "flex min-h-12 w-full items-start gap-3 px-4 py-3 text-left transition-colors hover:bg-emerald-50/70 focus-visible:bg-emerald-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-emerald-500",
        !n.is_read && "bg-emerald-50/50"
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          "mt-1.5 h-2 w-2 shrink-0 rounded-full",
          n.is_read ? "bg-transparent" : "bg-emerald-600"
        )}
      />
      <span className="min-w-0 flex-1">
        {!n.is_read && <span className="sr-only">Não lida: </span>}
        <span
          className={cn(
            "line-clamp-1 text-sm leading-snug",
            n.is_read ? "font-medium text-slate-700" : "font-semibold text-slate-900"
          )}
        >
          {n.title}
        </span>
        {n.body && (
          <span className="mt-0.5 line-clamp-1 text-[13px] leading-snug text-slate-500">
            {n.body}
          </span>
        )}
        <time
          dateTime={n.created_at}
          title={dataHoraCompleta(n.created_at)}
          className="mt-1 block text-xs text-slate-500"
        >
          {tempoRelativo(n.created_at)}
        </time>
      </span>
    </button>
  );
}
